import { InvestmentState as investmentState } from '@interfaces/state/investment-objectives/investment-objectives.interface';
import { Action, createReducer, on } from '@ngrx/store';
import {
  normalizeObjectives,
  toBooleanStatus,
} from '@sharedUtils/investment-objectives-utils.helper';
import {
  ResetInvestmentObjectives,
  UpdateInvestmentObjectives,
} from '@store/actions/investment-objectives/investment-objectives.action';
import { StartOverStateCleared } from '@store/actions/start-over/start-over.actions';

export const INVESTMENT_OBJECTIVES_FEATURE_KEY = 'investmentObjectives';

export interface InvestmentState extends investmentState {}

export const initialInvestmentObjectivesState: InvestmentState = {
  objectives: { CAP: null, Income: null, Growth: null, Speculation: null },
  objectivesStatus: false,
};

export const investmentObjectivesReducer = createReducer(
  initialInvestmentObjectivesState,
  on(UpdateInvestmentObjectives, (state, { objectives, objectivesStatus }) => {
    const nextObjectives = objectives
      ? normalizeObjectives({ ...state.objectives, ...objectives })
      : state.objectives;
    const nextStatus =
      typeof objectivesStatus === 'boolean' ? objectivesStatus : toBooleanStatus(nextObjectives);

    return {
      ...state,
      objectives: nextObjectives,
      objectivesStatus: nextStatus,
    };
  }),
  on(ResetInvestmentObjectives, () => initialInvestmentObjectivesState),
  on(StartOverStateCleared, () => initialInvestmentObjectivesState),
);

export function reducer(state: InvestmentState | undefined, action: Action) {
  return investmentObjectivesReducer(state, action);
}

export type InvestmentObjectivesState = InvestmentState;
